// extracted by mini-css-extract-plugin
export var header = "_gn-0";